var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 0H10C4.47715 0 0 4.47715 0 10V25C0 30.5228 4.47715 35 10 35H25C30.5228 35 35 30.5228 35 25V10C35 4.47715 30.5228 0 25 0Z",
    fill: "#FFF595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.005C17 19.8737 17.0259 19.7436 17.0761 19.6223C17.1264 19.501 17.2 19.3908 17.2929 19.2979C17.3858 19.205 17.496 19.1314 17.6173 19.0811C17.7386 19.0309 17.8687 19.005 18 19.005C18.1313 19.005 18.2614 19.0309 18.3827 19.0811C18.504 19.1314 18.6142 19.205 18.7071 19.2979C18.8 19.3908 18.8736 19.501 18.9239 19.6223C18.9741 19.7436 19 19.8737 19 20.005C19 20.2702 18.8946 20.5246 18.7071 20.7121C18.5196 20.8996 18.2652 21.005 18 21.005C17.7348 21.005 17.4804 20.8996 17.2929 20.7121C17.1054 20.5246 17 20.2702 17 20.005ZM17.098 14C17.0847 13.8738 17.098 13.7463 17.1372 13.6256C17.1764 13.505 17.2405 13.3939 17.3253 13.2996C17.4102 13.2053 17.5139 13.1299 17.6298 13.0783C17.7457 13.0267 17.8711 13 17.998 13C18.1249 13 18.2503 13.0267 18.3662 13.0783C18.4821 13.1299 18.5858 13.2053 18.6707 13.2996C18.7555 13.3939 18.8196 13.505 18.8588 13.6256C18.898 13.7463 18.9113 13.8738 18.898 14L18.548 17.507C18.5362 17.6448 18.4732 17.7731 18.3714 17.8666C18.2695 17.9602 18.1363 18.0121 17.998 18.0121C17.8597 18.0121 17.7265 17.9602 17.6246 17.8666C17.5228 17.7731 17.4598 17.6448 17.448 17.507L17.098 14Z",
    fill: "#FFF595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.49e63ee41f0c3d2131f940e5ed78f91c.svg";
export { ForwardRef as ReactComponent };